import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative aspect-w-1 aspect-h-1 md:aspect-w-4 md:aspect-h-1"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "absolute top-0 h-full w-full flex items-center justify-center" }
const _hoisted_4 = { class: "font-bold text-white text-center font-sarabun lg-text-80px text-40px" }
const _hoisted_5 = { class: "py-28 md:pt-32" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"32px"},
  class: "font-extrabold text-center"
}, " FOLLOW US FOR WEEKLY UPDATES ", -1)
const _hoisted_7 = {
  class: "mt-8 flex items-center justify-center space-x-4",
  style: {}
}
const _hoisted_8 = ["href", "data-testid"]
const _hoisted_9 = ["src"]

import ForestInformation from '@/components/ourForest/ForestInformation.vue';
import ForestDetailYear from '@/components/ourForest/ForestDetailYear.vue';
import ForestInFocus from '@/components/ourForest/ForestInFocus.vue';
import ForestGallery from '@/components/ourForest/ForestGallery.vue';
import ForestTimelapse from '@/components/ourForest/ForestTimelapse.vue';
import { onMounted } from 'vue';
import useForest from '@/composables/useForest';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { forestDetail, forestSummaries, getForestDetail } = useForest();

onMounted(async () => {
  await getForestDetail();
});
const socials = [
  {
    img: '/images/our-forest/social/facebook.png',
    to: 'https://web.facebook.com/Bringbacktheforest?_rdc=1&_rdr',
  },
  {
    img: '/images/our-forest/social/twitter.png',
    to: 'https://twitter.com/bbtfbbtf?s=21',
  },
  {
    img: '/images/our-forest/social/youtube.png',
    to: 'https://www.youtube.com/channel/UCgexR3KciJ3ZWsBOqV28HQA',
  },
  {
    img: '/images/our-forest/social/ig.png',
    to: 'https://www.instagram.com/bringbacktheforestbbtf/?igshid=YmMyMTA2M2Y%3D',
  },
  {
    img: '/images/our-forest/social/tiktok.png',
    to: 'https://www.tiktok.com/@bringbacktheforest',
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(forestDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            style: {},
            src: _unref(forestDetail).image.original_image_url,
            alt: "",
            class: "w-screen object-cover"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(forestDetail).name), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ForestInformation, {
      class: "md:my-32",
      style: {"margin-top":"84px","margin-bottom":"84px"}
    }),
    _createVNode(ForestDetailYear, {
      class: "md:my-32",
      style: {"margin-top":"84px","margin-bottom":"84px"}
    }),
    _createVNode(ForestTimelapse),
    _createVNode(ForestInFocus, {
      article: _unref(forestSummaries)?.article,
      class: "px-4 md:mt-32",
      style: {"margin-top":"120px"}
    }, null, 8, ["article"]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (s, i) => {
          return _createElementVNode("a", {
            key: `social-${i}`,
            class: "m-1 w-12",
            target: "_blank",
            href: s.to,
            "data-testid": `social-${i}`
          }, [
            _createElementVNode("img", {
              class: "w-16",
              src: s.img
            }, null, 8, _hoisted_9)
          ], 8, _hoisted_8)
        }), 64))
      ])
    ]),
    _createVNode(ForestGallery)
  ]))
}
}

})